module.exports = __webpack_public_path__ + "static/media/robot.2967b4e3.png";